require('./view.component.scss');

class ViewController {
  constructor(
    $scope,
    $element,
    $rootScope,
    CurrentFilterService,
    CurrentModelService,
    CurrentFilterDataService,
    PermissionService,
    RouterService,
    LayoutService,
  ) {
    this.$scope = $scope;
    this.$element = $element;
    this.CurrentFilterService = CurrentFilterService;
    this.CurrentModelService = CurrentModelService;
    this.CurrentFilterDataService = CurrentFilterDataService;
    this.permission = PermissionService;
    this.router = RouterService;
    this.layout = LayoutService;
  }

  get isDashbordOrCard() {
    return this.filter && (this.filter.isCard || this.filter.isDashboard);
  }

  get filter() {
    // console.log(this.CurrentFilterService.filter);
    return this.CurrentFilterService.filter;
  }

  get filterBar() {
    return this.CurrentFilterService.filterBar;
  }

  get isShowFilter() {
    return (this.filterEdit && this.router.isFilterEditModal) ||
      (!this.filterEdit && !this.router.isFilterEditModal);
  }

  get isShowStatHeader() {
    return !this.frameUrl && !this.isRemoteUsers && this.filter &&
      !this.filter.isDashboard && !this.filter.isCard && !this.filter.isHeatmap &&
      (this.filter.isGraph || this.filter.isAnalysis) && !this.filter.isStat;
  }

  // get isReadOnlyStatHeader() {
  //   return this.filter.isDashboard || this.filter.isCard;
  // }


  get model() {
    return this.CurrentModelService.model;
  }

  get filterData() {
    return this.CurrentFilterDataService.filterData;
  }

  get frameUrl() {
    return this.CurrentFilterService.frameUrl;
  }

  set frameUrl(value) {
    this.CurrentFilterService.frameUrl = value;
  }

  get isShowQuad() {
    return this.router && (this.router.isRemoteUsers || this.router.isLastScreenshots);
  }

  getHeightPx() {
    if (this.layout.isPrint && (this.filter.isAnalysis)) {
      return this.$element.width() * 0.618;
    }
  }

  getHeight() {
    const height = this.getHeightPx();
    if (!height) {
      return '100%';
    }
    return (height) + 'px';
  }
}

export const ViewComponent = {
  template: require('./view.component.html'),
  bindings: {
    filterEdit: '<'
  },
  controller: ViewController,
};



// WEBPACK FOOTER //
// ./src/view/view.component.js